import {
    Alert,
    Button,
    Col,
    Container,
    Icon,
    Input,
    Label,
    Modal,
    Popover,
    PopoverBody,
    PopoverHeader,
    Row,
    Table,
} from "design-react-kit";
import React, {useEffect, useMemo, useRef, useState} from "react";
import { properties } from "../../config/properties";
import {isDisabled} from "@testing-library/user-event/dist/utils";
import {useNavigate} from "react-router-dom";
import Spinner from "../layout/Spinner";

const styles = {
    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '90vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    titleIcon: {
        marginRight: '0.75rem',
    },
    // MODIFICATO: Aggiunta delle proprietà per rendere l'header "adesivo"
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },
    firmaImage: {

        /*
        maxWidth: '100%',
        width: 'auto',
        maxHeight: '200px',


         */

        maxWidth: '100%',
        width: 'auto',
        height: '150px',
        minHeight: '150px',
        maxHeight: '150px',

        objectFit: 'contain',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        backgroundColor: '#f8f9fa',
        padding: '0.5rem',
        display: 'block',

    },
    firmaPlaceholder: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '120px',
        backgroundColor: '#f8f9fa',
        border: '1px dashed #ced4da',
        borderRadius: '6px',
        color: '#6c757d',
        fontStyle: 'italic',
        fontSize: '0.9rem',
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    fieldLabel: {
        fontWeight: '500',
        color: '#6c757d',
        marginBottom: '0.25rem',
        fontSize: '0.9rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
    },
};

function FirmaComponent({ base64String, label }) {
    if (!base64String) {
        return (
            <div style={styles.firmaPlaceholder}>
                <span>Nessuna {label}</span>
            </div>
        );
    }
    const imgSrc = base64String.startsWith("data:image")
        ? base64String
        : `data:image/png;base64,${base64String}`;

    return <img src={imgSrc} alt={label} style={styles.firmaImage} />;
}


const Pubblica = ({user}) => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);

    const [colShow, setColShow] = useState(12)
    const [selectedFirma, setSelectedFirma] = useState(null);
    const [selectedDeleghe, setSelectedDeleghe] = useState(null);
    const [selectedNome, setSelectedNome] = useState(null);
    const [selectedCognome, setSelectedCognome] = useState(null);

    const [selectedRows, setSelectedRows] = useState({});

    const hasSelections = useMemo(() => {
        return Object.values(selectedRows).some(Boolean);
    }, [selectedRows]);

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const [loadingUser, setLoadingUser] = useState(true);




    function showDeleghe(deleghe, nome, cognome) {
        setSelectedDeleghe(deleghe);
        if(nome !== selectedCognome && cognome !== selectedCognome){
            setSelectedNome(nome);
            setSelectedCognome(cognome);
            setSelectedFirma(null);
        }
        setColShow(7);

    }

    function showFirma(firma, nome, cognome) {
        setSelectedFirma(firma);
        if(nome !== selectedCognome && cognome !== selectedCognome){
            setSelectedNome(nome);
            setSelectedCognome(cognome);
            setSelectedDeleghe(null);
        }
        setColShow(7);

    }

    function closeCard() {
        setSelectedFirma(null);
        setSelectedDeleghe(null);
        setSelectedNome(null);
        setSelectedCognome(null);
        setColShow(12);
    }

    const handleSubmitTutti = async () => {

        setAlert({ visible: false, type: '', message: '' });

        //fare chiamata senza limiti ed reimpostare data

        const payload = data.map(row => ({
            firmaId: row.firma?.id || null,
            idPersoneDeleghe: row.idPersoneDeleghe || []
        }));

        const payloadToSend = {
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente,
            data:payload
        };

        if (payload.length === 0) {
            setAlert({ visible: true, type: 'warning', message: 'Nessun record disponibile per la pubblicazione.' });
            return;
        }

        try {


            const response = await fetch(
                `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/pubblicaPersone`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payloadToSend)
                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const json = await response.json();

            if (json.esito === "OK") {

                const refreshedData = await getPersonePubblicazione();
                setAlert({ visible: true, type: 'success', message: json.messaggio });
                setData(refreshedData);
                setSelectedRows({});
            } else {
                setAlert({ visible: true, type: 'danger', message: json.messaggio });
            }
        } catch (error) {
            setAlert({ visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.' });
        }finally {
            closeCard();
        }
    };


    const handleSubmitSelezionati = async () => {
        const righeSelezionate = data.filter(row => selectedRows[row.id]);

        if (righeSelezionate.length === 0) {
            setAlert({ visible: true, type: 'warning', message: 'Nessuna riga selezionata.' });
            return;
        }

        const payload = righeSelezionate.map(row => ({
            firmaId: row.firma?.id || null,
            idPersoneDeleghe: row.idPersoneDeleghe || [],
        }));

        const payloadToSend = {
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente,
            data:payload
        };

        try {
            const response = await fetch(
                `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/pubblicaPersone`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payloadToSend)
                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const json = await response.json();

            if (json.esito === "OK") {

                const refreshedData = await getPersonePubblicazione();
                setAlert({ visible: true, type: 'success', message: json.messaggio });
                setData(refreshedData);
                setSelectedRows({});
            } else {
                setAlert({ visible: true, type: 'danger', message: json.messaggio });
            }

        } catch (error) {
            setAlert({ visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.' });
        }finally {
            closeCard();
        }
    };





    async function getPersonePubblicazione() {
        try {
            setAlert({ visible: false, type: '', message: '' });
            setLoadingUser(true);

            const res = await fetch(
                `${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/getPersonePubblicazione`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();
            return json.dataPersone || [];

        } catch (e) {

            setAlert({ visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.' });

            return [];
        }finally {
            setLoadingUser(false);
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            const persone = await getPersonePubblicazione();
            setData(persone);
        };
        fetchData();
    }, []);



    async function goToModificaPersona(id){

        const idProfilo = {
            id : id
        };


        navigate('/private/modificaPersona', { state: { idProfilo : idProfilo  } });
    }

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento
        return (
            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">
                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <Spinner active/>
            </Container>
        );
    }

    return (
        <Container className="bg-white py-3 py-lg-6">

            <Container className={"py-lg-5 py-lg-6"}>

                <div style={{display: "flex"}}>
                    <div style={{flex: 1}}>
                        <h2 className="mb-5">Pubblicazione</h2>
                    </div>
                    <div style={{flex: 1}} align={"right"}></div>
                </div>

                <Row className={"mb-5"}>
                    <Col md={4}>
                        <div className="guidance-box lead">
                            <p>
                                Specimen non pubblicati
                            </p>

                        </div>
                    </Col>

                    <Col md={8} className={"text-end"}>
                        <Button
                            className="btn btn-outline-primary"
                            onClick={handleSubmitTutti}

                        >
                            Pubblica Tutti
                        </Button>

                        <Button
                            className="btn btn-outline-primary"
                            onClick={handleSubmitSelezionati}
                            style={{marginLeft: "30px"}}
                            disabled={!hasSelections}
                        >
                            Pubblica selezionati
                        </Button>

                    </Col>

                </Row>


                <Row>
                    <Col md={colShow}>

                        {alert.visible && (
                            <Alert color={alert.type} isOpen={alert.visible}
                                   toggle={() => setAlert({...alert, visible: false})}>
                                {alert.message}
                            </Alert>
                        )}

                        <div style={styles.tableContainer}>
                            <Table hover className="border-0">
                                <thead>
                                <tr style={styles.tableHeader}>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Seleziona</th>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Nome</th>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Cognome</th>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Codice Fiscale</th>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Firma Inserita</th>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Nuove deleghe</th>
                                    <th scope="col" className="text-left" style={styles.tableHeader}>Modifica</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.length > 0 ? (
                                    data.map((row) => (
                                        <tr key={row.id}>
                                            <td>
                                                <input
                                                    style={styles.tableRowText}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={selectedRows[row.id] || false}
                                                    onChange={(e) => {
                                                        setSelectedRows((prev) => ({
                                                            ...prev,
                                                            [row.id]: e.target.checked,
                                                        }));
                                                    }}
                                                    aria-label={`Seleziona riga ${row.id}`}
                                                />

                                            </td>
                                            <td style={styles.tableRowText}>{row.nome}</td>
                                            <td style={styles.tableRowText}>{row.cognome}</td>
                                            <td style={styles.tableRowText}>{row.codiceFiscale}</td>
                                            <td
                                                className="action-icon text-center"
                                                style={{...styles.actionButton, ...styles.tableRowText}}
                                            >
                                                {row.firma && row.firma.id ? (
                                                    <Icon
                                                        color="success"
                                                        icon="it-check-circle"
                                                        onClick={() => showFirma(row.firma, row.nome, row.cognome)}
                                                    />
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            {row.deleghe && row.deleghe.length > 0 ? (
                                                    <td
                                                        className="action-icon text-center"
                                                        style={{...styles.actionButton, ...styles.tableRowText}}
                                                        onClick={() => showDeleghe(row.deleghe, row.nome, row.cognome)}
                                                    >
                                                        <span>{row.deleghe.length}</span>

                                                    </td>
                                                ) :
                                                <td
                                                    className="action-icon text-center"
                                                    style={{...styles.actionButton, ...styles.tableRowText}}
                                                >
                                                    <span>{row.deleghe.length}</span>

                                                </td>

                                            }
                                            <td
                                                className="action-icon text-center"
                                                style={{...styles.actionButton, ...styles.tableRowText}}
                                                onClick={() => goToModificaPersona(row.id)}
                                            >
                                                <Icon icon="it-pencil" color="primary"/>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            className="text-center"
                                            style={styles.tableRowText}
                                            colSpan="7"
                                        >
                                            Nessuno specimen da pubblicare
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>


                        </div>

                    </Col>

                    <Col className="col-md-5">
                        {(selectedFirma || selectedDeleghe) && (
                            <div style={{
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                padding: '1rem',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                backgroundColor: '#fff',
                                position: 'relative',
                            }}>
                                <button
                                    onClick={closeCard}
                                    style={{
                                        position: 'absolute',
                                        top: '0.5rem',
                                        right: '0.5rem',
                                        border: 'none',
                                        background: 'transparent',
                                        fontSize: '1.2rem',
                                        cursor: 'pointer'
                                    }}
                                    aria-label="Chiudi"
                                >
                                    ×
                                </button>

                                <h2>
                                    {selectedNome} {selectedCognome}
                                </h2>

                                {selectedFirma && (
                                    <>
                                        <h5 style={{...styles.sectionTitle}}>
                                            <Icon icon="it-pencil" size="sm" style={styles.titleIcon}/>
                                            Firma non ancora pubblicata
                                        </h5>
                                        <Row className="mb-4">
                                            <Col>
                                                <FirmaComponent base64String={selectedFirma.firma} label="firma"/>
                                            </Col>
                                            <Col>
                                                <FirmaComponent base64String={selectedFirma.firmaSigla} label="sigla"/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p style={{...styles.fieldValue}}>Firma depositata
                                                    il: {selectedFirma.dtFirma[0]}-{selectedFirma.dtFirma[1]}-{selectedFirma.dtFirma[2]}</p>
                                            </Col>
                                            <Col>
                                                <p>
                                                    {/* Stato:&nbsp; */}
                                                    <p style={{...styles.fieldValue, color: "red"}}>
                                                        {selectedFirma.stato === 'INS' ? 'NON PUBBLICATA' : 'Errore'}
                                                    </p>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {selectedDeleghe && (
                                    <>

                                        <h5 style={styles.sectionTitle}>
                                            <Icon icon="it-key" size="sm" style={styles.titleIcon}/>
                                            Deleghe non ancora pubblicate
                                        </h5>
                                        {selectedDeleghe.map((delega, index) => (
                                            <div key={index} style={{
                                                marginBottom: '1rem',
                                                paddingBottom: '0.5rem',
                                                borderBottom: '1px solid #e0e0e0'
                                            }}>
                                                <p style={{ ...styles.fieldValue, fontSize: "x-large" }}>{delega.descDelega || 'N/D'}</p>
                                                <div style={{display: 'flex', gap: '1rem'}}>
                                                    <p style={{...styles.fieldValue}}>Valida dal: {delega.dataInizio || 'N/D'}</p>
                                                    <p style={{...styles.fieldValue}}>Al: {delega.dataFine || 'N/D'}</p>
                                                </div>
                                                <p style={{...styles.fieldValue, color: "red"}}>
                                                NON PUBBLICATA
                                                </p>

                                            </div>
                                        ))}


                                    </>
                                )}
                            </div>
                        )}
                    </Col>


                </Row>

            </Container>

        </Container>
    );
};

export default Pubblica;
